import React, { useState } from "react";
import RcvBallotView from "./RcvBallotView";

export default function RcvBallot({
  race,
  candidates,
  onUpdate,
  defaultRankings,
  readonly
}) {
  // Check for multiple candidates receiving the same ranking

  const countMatching = (arr, match) =>
    arr.reduce((count, value) => (value === match ? count + 1 : count), 0);

  const validate = rankings => {
    const errors = Array(candidates.length).fill(false);
    var ranking;
    for (ranking = 1; ranking <= candidates.length; ranking++) {
      const error = countMatching(rankings, ranking) > 1;
      errors[ranking - 1] = error;
    }
    return errors;
  };
  const hasErrors = errors => errors.some(bool => bool);

  const [rankings, setRankings] = useState(
    defaultRankings ? defaultRankings : Array(candidates.length).fill(0)
  );
  const [errors, setErrors] = useState(
    defaultRankings
      ? validate(defaultRankings)
      : Array(candidates.length).fill(false)
  );

  return (
    <RcvBallotView
      key="rcvBallot"
      race={race}
      candidates={candidates}
      rankings={rankings}
      errors={errors}
      onClick={(i, j) => {
        console.log(`${candidates[i].candidate} = ${j}`);
        const newRankings = [...rankings];
        newRankings[i] = newRankings[i] === j ? 0 : j;
        setRankings(newRankings);
        const newErrors = validate(newRankings);
        setErrors(newErrors);
        onUpdate(newRankings, hasErrors(newErrors));
      }}
      readonly={readonly}
    />
  );
}
